import { Injectable } from '@angular/core';
import { identity } from 'lodash';
import { DataService } from './data.service';
import * as CryptoJS from 'crypto-js';
import * as forge from 'node-forge';

@Injectable()
export class CashBookingService {
  publicKey: string = `-----BEGIN PUBLIC KEY-----
    MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAoRuUJ/00OTIh82a1EfXu
    Qp1QfPn3bQPSjt/7h3EvYceB/bCsLgofbKQ+kvwTSz0ERNKTcSB3XUvu02VMk5YK
    bkAIchEacdYFqDDnw9nACFZJn3qyJI/SF5m7JUiaf3KS2trUh+whCHBE/TzezBx+
    I+WNrOeCUdnd0XXuTIOyay9E+E//4nUZgmJ9XY/Jjb81sq1voxV6pVy1+BEel4BQ
    sBnAxNWEx9KTlpMjuHK2aqOkCNTTv5G0yefGdWcXIGdFXOhECE9b12p3Nc4OGx5d
    /LKb7m2kSeKjj1jPnjNHVDrnrzRnEcIKmDjwAL7FequkW3OYhmP/enuvYL55GTyA
    fwIDAQAB
    -----END PUBLIC KEY-----`;
  tokenFromUI: string = "1e2f3g4c5h7a8x9q";
  tokenFromIV: any;
  otpEncrypt: any;

  constructor(private dataService: DataService) {
  };

  generateOTP(result: any, refresh: boolean) {
    // return this.dataService.getData('/api/user/generateOtp' + id, refresh);
    return this.dataService.post('/api/user/generateOtp', result).map(response => {
      return response;
    });
  }

  verifyMobileNo(data) {
    //return this.dataService.post('/api/user/generateOtp', data);
    return this.dataService.getData('/api/user/validateUser/' + data, true);
  }

  otpVerification(result: any, refresh: boolean) {
    // this.tokenFromIV = (Math.random() + ' ').substring(2, 10) + (Math.random() + ' ').substring(2, 10);
    // if (result.otp) {
    //     let _key = CryptoJS.enc.Utf8.parse(this.tokenFromUI);
    //     let _iv = CryptoJS.enc.Utf8.parse(this.tokenFromIV);
    //     let encrypted = CryptoJS.AES.encrypt(
    //         JSON.stringify(result.otp), _key, {
    //         keySize: 16,
    //         iv: _iv,
    //         mode: CryptoJS.mode.ECB,
    //         padding: CryptoJS.pad.Pkcs7
    //     });

    //     this.otpEncrypt = this.tokenFromIV + encrypted.toString();
    //     // var encryptKeyIv = this.tokenFromIV + encrypted.toString();
    // }
    // data.otp = btoa(this.otpEncrypt)
    var rsa = forge.pki.publicKeyFromPem(this.publicKey);
    var encryptedPassword = window.btoa(rsa.encrypt(result.otp));
    const data = {
      mobileNumber: result.mobileNumber,
      otp: encryptedPassword
    }
    // return this.dataService.getData('/api/user/generateOtp' + id, refresh);
    return this.dataService.post('/api/user/otpVerify', data).map(response => {
      return response;
    });
    // return this.dataService.getData('/api/user/getOtpVerify/' + data.mobileNumber + '/' + data.otp, refresh).map(response => {
    //     return response;
    // });
  }

  bookingAvailability(vehicleCategoryId, blockId, refresh: boolean) {
    // return this.dataService.getData('/api/mhirebooking/availabilityDate/' + vehicleCategoryId + '/' + talukId, refresh)
    return this.dataService.getData('/api/mhirebooking/availabilityDate/' + vehicleCategoryId + '/' + blockId, refresh)

  }

  postUser(result: any, refresh: boolean) {
    return this.dataService.post('/api/user/registration', result).map(response => {
      return response;
    });
  }
  postFarm(result: any, refresh: boolean) {
    return this.dataService.post('/api/mhire/mhireUserFarmSave', result).map(response => {
      return response;
    });
  }
  emailSave(result: any, refresh: boolean) {
    return this.dataService.post('/api/user/emailsave', result).map(response => {
      return response;
    });
  }
  postAccountDetails(result: any, refresh: boolean) {
    return this.dataService.post('/api/farmeraccountdetail', result).map(response => {
      return response;
    });
  }
  postCashBooking(result: any, refresh: boolean) {
    return this.dataService.post('/api/mhire/mhireBookingSave', result).map(response => {
      return response;
    });
  }
  // getCashBookingList(regionId:any,divisionId,subdivisionId,isCash, refresh: boolean) {
  //     return this.dataService.getData('/api/booking/'+regionId+'/'+divisionId+'/'
  //     +subdivisionId+'/'+isCash,refresh).
  //     map(response => {
  //         return response;
  //     });
  // }

  getCashBookingList(data: any, refresh: boolean) {
    return this.dataService.getData('/api/booking/' + data.region + '/' + data.division + '/' + data.subdivision + '/' + data.bookingStatusType + '/' + data.isCashBooking+'/'+ data.financialYearId, refresh);
  }
  getCashBookingByBookingId(data: any, refresh: boolean) {
    return this.dataService.getData('/api/mhire/bookedInfoById/' + data.bookingId + '/' + data.langType, refresh);
  }

  getBookingStatusList(refresh: boolean) {
    return this.dataService.getData("/api/mhire/bookingstatustype", refresh);
  }

  getpaccstype(refresh: boolean) {
    return this.dataService.getData("/api/lookup/paccstype", refresh);
  }

  getSecretaryStatusType(refresh: boolean) {
    return this.dataService.getData("/api/lookup/secretarystatustype", refresh);
  }

  getFocsrApprovedStatusType(refresh: boolean) {
    return this.dataService.getData("/api/lookup/focsrapprovedstatustype", refresh);
  }

  getPaccsReportApprovalStatusType(refresh: boolean) {
    return this.dataService.getData('/api/lookup/paccsreportapprovalstatus', refresh);
  }

  getTariffStatusType(refresh: boolean) {
    return this.dataService.getData('/api/lookup/tariffstatus', refresh);
  }

  getDriverStatusType(refresh: boolean) {
    return this.dataService.getData('/api/lookup/driverstatus', refresh);
  }

  getMachinaryType(refresh: boolean) {
    return this.dataService.getData('/api/lookup/machinarytype', refresh);
  }

  tariffCheck(data: any) {
    return this.dataService.post('/api/mhire/mhireBookingTariffCheck', data).map(response => {
      return response;
    });
  }

  getUserDetails(userId: any, langType: any, refresh: boolean) {
    return this.dataService.getData('/api/user/getMhireUser/' + userId + '/' + langType, refresh).
      map(response => {
        return response;
      });
  }

  getUserFarmerDetails(userId: any, refresh: boolean) {
    return this.dataService.getData('/api/farmeraccountdetail/getbyuser/' + userId, refresh).
      map(response => {
        return response;
      });
  }

  getValidateUserDetails(mobileNo: any, refresh: boolean) {
    return this.dataService.getData('/api/user/validateUser/' + mobileNo, refresh).
      map(response => {
        return response;
      });
  }

  getUserFarm(farmerId: any, langType: any, refresh: boolean) {
    return this.dataService.getData('/api/mhire/getAllFarm/' + farmerId + '/' + langType, refresh).
      map(response => {
        return response;
      });
  }

  getSubDivisionId(data: any, refresh: boolean) {
    return this.dataService.getData('/api/mhire/getUserbyTaluk/' + data.talukId + '/' + data.blockId + '/' + data.langType, refresh)
  }

  getUserbyVillage(data: any, refresh: boolean) {
    return this.dataService.getData('/api/mhire/getUserbyTaluk/' + data.talukId + '/' + data.blockId + '/' + data.langType, refresh)
  }

  // getSubDivisionId(talukId:any,langType:any, refresh: boolean) {
  //     return this.dataService.getData('api/mhire/getUserbyTaluk/'+talukId+'/'+langType,refresh).
  //     map(response => {
  //         return response;
  //     });
  // }

  getMachineryList(blockId: any, langType: any, refresh: boolean) {
    // return this.dataService.getData('/api/mhire/vehicleList/'+talukId+'/'+langType,refresh).
    return this.dataService.getData('/api/mhire/vehicleList/' + blockId + '/' + langType, refresh).

      map(response => {
        return response;
      });
  }
  getMachineryListBySubdivision(UserSubDivision: any, langType: any, refresh: boolean) {
    // return this.dataService.getData('/api/mhire/vehicleList/'+talukId+'/'+langType,refresh).
    return this.dataService.getData('/api/mhire/vehicleListbysubdivision/' + UserSubDivision + '/' + langType, refresh).

      map(response => {
        return response;
      });
  }
  getImplementList(blockId: any, vehicleCategoryId: any, langType: any, refresh: boolean) {
    return this.dataService.
      // getData('/api/mhire/implementList/'+talukId+'/'+vehicleCategoryId+'/'+langType,refresh).
      getData('/api/mhire/implementList/' + blockId + '/' + vehicleCategoryId + '/' + langType, refresh).

      map(response => {
        return response;
      });
  }

  getImplementListBySubDivision(UserSubDivision: any, vehicleCategoryId: any, langType: any, refresh: boolean) {
    return this.dataService.
      // getData('/api/mhire/implementList/'+talukId+'/'+vehicleCategoryId+'/'+langType,refresh).
      getData('/api/mhire/implementListBySubDivision/' + UserSubDivision + '/' + vehicleCategoryId + '/' + langType, refresh).

      map(response => {
        return response;
      });
  }
  getBookingInfo(bookingId: any, langType: any, refresh: boolean) {
    return this.dataService.
      getData('/api/mhire/bookedInfoById/' + bookingId + '/' + langType, refresh).
      map(response => {
        return response;
      });
  }
  getFarmList(id: any, refresh: boolean) {
    return this.dataService.getData('/api/mhire/getAllFarm/' + id, refresh).map(response => {
      return response;
    });
  }
  getbookingcheck(id: number, refresh: boolean) {
    return this.dataService.getData('/api/mhire/bookingcheck/' + id, refresh);
  }
  districtData(id: any, refresh: boolean) {
    return this.dataService.getData('/api/mhire/district/' + id, refresh).map(response => {
      return response;
    });
  }
  getpaccsbookingtarget(goId: any, componentId: any, productId: any, refresh: boolean) {
    return this.dataService.getData('/api/paccsbooking/targetcheck/' + goId + '/' + componentId + '/' + productId, refresh).map(response => {
      return response;
    });
  }
  getunmappedvillage(districtId: any, refresh: boolean) {
    return this.dataService.getData('/api/subdivision/unmappedvillage/' + districtId, refresh).map(response => {
      return response;
    });
  }
  getDistrictWiseBock(bookingId: any, langType: any, refresh: boolean) {
    return this.dataService.
      getData('/api/mhire/block/' + bookingId + '/' + langType, refresh).
      map(response => {
        return response;
      });
  }
  getmappedvillage(blockId: any, refresh: boolean) {
    return this.dataService.getData('/api/subdivision/mappedvillage/' + blockId, refresh).map(response => {
      return response;
    });
  }
  districtBySubDivision(id: any, refresh: boolean) {
    return this.dataService.getData('/api/mhire/districtBySubDivision/' + id, refresh).map(response => {
      return response;
    });
  }

  getGenderType(refresh: boolean) {
    return this.dataService.getData('/api/lookup/gendertype', refresh);
  }

  districtByState(id: any, refresh: boolean) {
    return this.dataService.getData('/api/mhire/district/' + id + "/" + 1, refresh).map(response => {
      return response;
    });
  }
  talukData(districtID: any, langType, refresh: boolean) {
    return this.dataService.getData('/api/mhire/taluk/' + districtID + '/' + langType, refresh)
      .map(response => {
        return response;
      });
  }
  talukBySubDivision(districtID: any, langType, refresh: boolean) {
    return this.dataService.getData('/api/mhire/talukBySubDivision/' + districtID + '/' + langType, refresh)
      .map(response => {
        return response;
      });
  }
  blockData(districtid: any, langType: any, refresh: boolean) {
    return this.dataService.getData('/api/mhire/uzhavanblock/' + districtid + '/' + langType, refresh)
      .map(response => {
        return response;
      });
  }
  villageData(blockid: any, langType: any, refresh: boolean) {
    return this.dataService.getData('/api/mhire/uzhavanvillage/' + blockid + '/' + langType, refresh)
      .map(response => {
        return response;
      });
  }
  getLookUpblockbyId(district: any, language: any, refresh: Boolean) {
    return this.dataService.getData('/api/mhire/block/' + district + '/' + language, refresh);
  }
  blockBySubDivision(district: any, language: any, refresh: Boolean) {
    return this.dataService.getData('/api/mhire/blockBySubDivision/' + district + '/' + language, refresh);
  }
  getvillageLookUp(taluk: any, language: any, refresh: Boolean) {
    return this.dataService.getData('/api/mhire/village/' + taluk + '/' + language, refresh);
  }

  getvillageList(block: any, language: any, refresh: Boolean) {
    return this.dataService.getData('/api/mhire/villagelist/' + block + '/' + language, refresh);
  }
  // getUserbyVillage(data: any, refresh: boolean) {
  //     return this.dataService.getData('/api/mhire/getUserbyTaluk/' + data.talukId + '/' + data.langType, refresh)
  // }

  getVechileByTaluk(data: any, refresh: boolean) {
    return this.dataService.getData('/api/mhire/vehicleList/' + data.talukId + '/' + data.langType, refresh)
  }

  getContinueHireComments(data: any, refresh: boolean) {
    return this.dataService.getData('/api/mhire/mhirecomments/' + data.key + '/' + data.langType, refresh)
  }


  getbookingstatustype(refresh: boolean) {
    return this.dataService.getData('/api/lookup/bookingstatustype', refresh);
  }

  continueHire(data: any) {
    return this.dataService.post('/api/mhirebooking/extension', data).map(response => {
      return response;
    });
  }


  downloadbookingPdf(result: any) {
    return this.dataService.post('/api/report/receipt/', result).map(response => {
      // this.dataService.clearRouteCache(this.getEventRoute);
      return response;
    });
  }


  getperDayHours(data: any, refresh: boolean) {
    return this.dataService.getData('/api/mhire/mhirecomments/' + data.key + '/' + data.langType, refresh)
  }
  demoVideo(data: any, refresh: boolean) {
    return this.dataService.getData('/api/config/' + data.key + '/' + data.langType, refresh)
  }


  getperEditDayHours(Data: any, refresh: boolean) {
    return this.dataService.getData('/api/mhire/mhirecomments/' + Data.key + '/' + Data.langType, refresh)
  }
  getMarqueeData(data: any, refresh: boolean) {
    return this.dataService.getData('/api/config/' + data.key + '/' + data.langType, refresh)
  }
  //bank services
  getbankName(refresh: boolean) {
    return this.dataService.getData('/api/bank/banklist', refresh)
  }

  getbankcity(id: any, refresh: boolean) {
    return this.dataService.getData('/api/bank/citylist/' + id, refresh)
  }
  getbranch(id: any, refresh: boolean) {
    return this.dataService.getData('/api/bank/branchlist/' + id, refresh)
  }

  serviceProviderUpdate(data: any) {
    return this.dataService.post('/api/user/serviceproviderandbankdetailsupdate', data).map((response) => {
      return response;
    });
  }

  banksave(data: any) {

    return this.dataService.post('/api/bank', data).map(res => {
      return res;
    })
  }
  getcommunityLookup(refresh: boolean) {
    return this.dataService.getData('/api/lookup/communityType', refresh)
  }
  getlandTypeLookup(refresh: boolean) {
    return this.dataService.getData('/api/lookup/landType', refresh)
  }
  getfarmerTypeLookup(refresh: boolean) {
    return this.dataService.getData('/api/lookup/farmerType', refresh)
  }

  getmachineryAndImplementStatusTypeLookup(refresh: boolean) {
    return this.dataService.getData('/api/lookup/machineryandimplementstatusType', refresh)
  }

  // subsidysave(data: any) {
  //     return this.dataService.post('/api/farmerbookingsubsidy/farmersubsidysave', data).map(res => {
  //         return res;
  //     })
  // }
  subsidysave(data: any) {
    return this.dataService.post('/api/farmerbookingsubsidy/farmersubsidysaveforcashbooking', data).map(res => {
      return res;
    })
  }
  subSidyCheck(id: any, refresh: boolean) {
    return this.dataService.getData('/api/farmerbookingsubsidy/issubsidycheck/' + id, true);
  }

  blockLookUp(id: any, langType: any, refresh: boolean) {
    return this.dataService.getData('/api/mhire/block/' + id + '/' + langType, refresh);
  }

  gramPanchayatLookUp(id: any, refresh: boolean) {
    return this.dataService.getData('/api/farmerregistration/grampanchayat/' + id, refresh);
  }

  getgramPanchayatData(blockId: any, langType: any, refresh: boolean) {
    return this.dataService.getData('/api/lookup/grampanchayat/' + blockId + '/' + langType, true)
  }

  districtLookup() {
    return this.dataService.getData('/api/mhire/district/' + 1, true)
  }

  talukLookup(districtId: any) {
    return this.dataService.getData('/api/mhire/taluk/' + districtId + '/' + 1, true)
  }

  blockLookup(districtId: any) {
    return this.dataService.getData('/api/mhire/block/' + districtId + '/' + 1, true)
  }

  getPAACSdata(userId: any, refresh: boolean) {
    return this.dataService.getData('/api/user/ispaacsuseruploadcheck/' + userId, refresh)
  }


  updatePAACS(data: any) {
    return this.dataService.post('/api/user/update', data).map(response => {
      return response;
    });
  }
  getByIdpaccsbooking(id: any, refresh: any) {
    // return this.dataService.post('/api/paccsbooking/', id).map(response => {
    //     return response;
    // });
    return this.dataService.getData('/api/paccsbooking/' + id, refresh)
  }
  savepaccsbookingSave(data: any) {
    return this.dataService.post('/api/paccsbooking/bookingsave', data).map(response => {
      return response;
    });
  }
  sanctioncancel(data: any) {
    return this.dataService.post('/api/paccsbooking/sanctioncancel', data).map(response => {
      return response;
    });
  }

  savepaccsbookingValidate(data: any) {
    return this.dataService.post('/api/paccsbooking/bookingvalidate', data).map(response => {
      return response;
    });
  }
  getCropType(langType: any, refresh: boolean) {
    return this.dataService.getData('/api/lookup/crop/' + langType, refresh);
  }

  getE2ECrop(landType: any, refresh: boolean, financialYearId: any = 0) {
    return this.dataService.getData('/api/lookup/e2ecrop/' + landType + '/' + (financialYearId || 0), refresh);
  }


  getBlockCrop(refresh: boolean, financialYearId: number = 0, divisionId: number = 0) {
    return this.dataService.getData('/api/e2etarget/divisiontargetbyblock' + (financialYearId || divisionId ? '/' + (financialYearId || 0) + '/' + (divisionId || 0) : ''), refresh);
  }

  userDetailsUpdate(data: any) {
    return this.dataService.post('/api/user/userdetailsupdate', data).map((response) => {
      return response;
    });
  }

  getCooperativeInstitution() {
    return this.dataService.getData('/api/lookup/paccstype', true);
  }


}
